import { render, staticRenderFns } from "./StatisticBody.vue?vue&type=template&id=24db5d4c&"
import script from "./StatisticBody.vue?vue&type=script&lang=js&"
export * from "./StatisticBody.vue?vue&type=script&lang=js&"
import style0 from "./StatisticBody.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports